import TablePagination from '@mui/material/TablePagination'

import { pdfjs, Document, Page } from 'react-pdf'
import VisibilityIcon from '@mui/icons-material/Visibility'
import DeleteIcon from '@mui/icons-material/Delete'
import DoneIcon from '@mui/icons-material/Done'
import DoneAllIcon from '@mui/icons-material/DoneAll'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import DangerousIcon from '@mui/icons-material/Dangerous'
const CryptoJS = require('crypto-js')
import { CountdownCircleTimer } from 'react-countdown-circle-timer'
import * as XLSX from 'xlsx/xlsx.mjs'
import { alpha } from '@mui/material/styles'
import { visuallyHidden } from '@mui/utils'
import EditOffIcon from '@mui/icons-material/EditOff'
import FilterListIcon from '@mui/icons-material/FilterList'
import FilterListOffIcon from '@mui/icons-material/FilterListOff'
import CachedIcon from '@mui/icons-material/Cached'
import LockIcon from '@mui/icons-material/Lock'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined'
import PropTypes from 'prop-types'
import { tablePaginationClasses as classes } from '@mui/base/TablePagination'
import { styled } from '@mui/system'
import {
  CAlert,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CCollapse,
  CContainer,
  CDropdown,
  CDropdownDivider,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CNavbar,
  CNavbarNav,
  CNavbarToggler,
  CRow,
  CSpinner,
} from '@coreui/react'
import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SaveIcon from '@mui/icons-material/Save'
import { openModal } from 'src/redux/slices/utilSlice/modalSlice'
import { ReactSpreadsheetImport } from 'react-spreadsheet-import'
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp'
import MuiAccordion from '@mui/material/Accordion'
import MuiAccordionSummary from '@mui/material/AccordionSummary'
import MuiAccordionDetails from '@mui/material/AccordionDetails'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import {
  Autocomplete,
  Avatar,
  Backdrop,
  Box,
  Button,
  Card,
  CardHeader,
  CardMedia,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  ListItemText,
  MenuItem,
  Paper,
  Select,
  Stack,
  Switch,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material'
import { SearchOutlined } from '@mui/icons-material'
import { getComparator, stableSort } from 'src/utils/filter'
import { useDisclosure } from '@chakra-ui/react'
import { Dropdown, DropdownDivider } from 'react-bootstrap'

import { changeYear, getYearList } from 'src/redux/slices/tableSlice/yearSlice'
import {
  getStudentByID,
  signReglement,
  updateProfileTeacher,
} from 'src/redux/slices/userSlice/authSlice'
import dayjs from 'dayjs'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { getAllMessages } from 'src/redux/slices/userSlice/messageSlice'
import renderHTML from 'react-render-html'

const Reglement = () => {
  const { student, currentStudentData, isLoading } = useSelector((state) => state.auth)

  const lang = student?.LANGUE_DEFAUT
  const dispatch = useDispatch()

  useEffect(() => {
    if (!currentStudentData || currentStudentData?.length === 0) {
      dispatch(getStudentByID({ MATRICULE: student?.MATRICULE }))
    }
  }, [dispatch])

  const [open, setOpen] = React.useState(false)

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      {currentStudentData && currentStudentData?.length > 0 ? (
        <>
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={isLoading}
            //onClick={handleClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <CRow>
            <CCol xs={12}>
              <CCard className="mb-4">
                <CCardHeader>
                  <strong>
                    {lang === 'Français' ? 'Règlement intérieur' : 'Internal regulations'}
                  </strong>
                </CCardHeader>
                <CCardBody>
                  <>
                    <Grid container spacing={2} sx={{ p: 1 }}>
                      <Grid item md={12} xs={12}>
                        {currentStudentData[0]?.ACTIVE_LDAP === '1' ? (
                          <Typography variant="subtitle1" gutterBottom>
                            Règlement intérieur approuvé le{' '}
                            {moment(currentStudentData[0]?.DATE_SIGNE).format('DD/MM/YYYY')}
                          </Typography>
                        ) : (
                          <>
                            {lang === 'Français' ? (
                              <>
                                <p>
                                  Veuillez prendre le temps de lire attentivement le règlement
                                  intérieur ci-dessous.
                                </p>
                                <p>Je soussigné,</p>
                                <p>
                                  <b>Nom & Prénom : </b> {currentStudentData[0]?.NOM_ETU}{' '}
                                  {currentStudentData[0]?.PRENOM_ETU}
                                </p>
                                <p>
                                  <b>Né(e) le : </b>{' '}
                                  {moment(currentStudentData[0]?.DT_NAIS_ETU).format('DD/MM/YYYY')}{' '}
                                  à {currentStudentData[0]?.WILAYA_NAIS}
                                </p>
                                <p>
                                  <b>Matricule : </b> {currentStudentData[0]?.MATRICULE}
                                </p>
                                <p>
                                  déclare avoir pris connaissance du règlement intérieur de
                                  l'établissement et m’engage sur l’honneur à le respecter
                                  scrupuleusement pendant toute ma formation.
                                </p>
                                <p>
                                  Toute mise à jour du règlement intérieur de l'établissement sera
                                  mise à disposition des étudiants et soumise de nouveau à
                                  signature.
                                </p>
                              </>
                            ) : (
                              <>
                                <p>
                                  Please take the time to carefully read the internal rules below
                                </p>
                                <p>i, the undersigned,</p>
                                <p>
                                  <b>Full name : </b> {currentStudentData[0]?.NOM_ETU}{' '}
                                  {currentStudentData[0]?.PRENOM_ETU}
                                </p>
                                <p>
                                  <b>Born on : </b>{' '}
                                  {moment(currentStudentData[0]?.DT_NAIS_ETU).format('DD/MM/YYYY')}{' '}
                                  in{' '}
                                  {currentStudentData[0]?.WILAYA_NAIS_EN ||
                                    currentStudentData[0]?.WILAYA_NAIS}
                                </p>
                                <p>
                                  <b>ID number : </b> {currentStudentData[0]?.MATRICULE}
                                </p>
                                <p>
                                  declares that I have read the internal regulations of the
                                  establishment and undertakes on honor to scrupulously respect them
                                  during all my training.
                                </p>
                                <p>
                                  Any update of the internal regulations of the institution will be
                                  made available to students and submitted again for signature.
                                </p>
                              </>
                            )}

                            <Grid item md={12} xs={12} justifyContent="flex-end">
                              <Box
                                sx={{ '& button': { m: 1 } }}
                                display="flex"
                                //justifyContent="flex-end"
                              >
                                <Button
                                  variant="contained"
                                  size="small"
                                  color="error"
                                  onClick={handleClickOpen}
                                >
                                  {lang === 'Français' ? 'Signer le règlement' : 'Sign '}
                                </Button>
                              </Box>
                            </Grid>
                          </>
                        )}
                      </Grid>
                    </Grid>
                    <Dialog
                      open={open}
                      onClose={handleClose}
                      aria-labelledby="alert-dialog-title"
                      aria-describedby="alert-dialog-description"
                    >
                      <DialogTitle id="alert-dialog-title">
                        {lang === 'Français' ? 'Règlement intérieur' : 'Rules of procedure'}
                      </DialogTitle>
                      <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                          {lang === 'Français'
                            ? `Voulez-vous vraiment signer le règlement intérieur de l'établissement ?`
                            : `Are you sure you want to sign the establishment's rules of procedure`}
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={handleClose}>{lang === 'Français' ? 'Non' : 'No'}</Button>
                        <Button
                          variant="contained"
                          onClick={async () => {
                            await dispatch(
                              signReglement({ MATRICULE: currentStudentData[0]?.MATRICULE, lang }),
                            )
                            if (!currentStudentData || currentStudentData?.length === 0) {
                              dispatch(getStudentByID({ MATRICULE: student?.MATRICULE }))
                            }
                            setOpen(false)
                          }}
                          autoFocus
                        >
                          {lang === 'Français' ? 'Oui' : 'Yes'}
                        </Button>
                      </DialogActions>
                    </Dialog>
                    <Grid container spacing={2} sx={{ p: 1 }}>
                      <Grid item md={12} xs={12}>
                        <iframe
                          src={`${process.env.REACT_APP_API_URL}/reglement_interieur.pdf`}
                          width="100%"
                          height="1000px"
                        ></iframe>
                      </Grid>
                    </Grid>

                    <Box sx={{ '& button': { m: 1 } }}></Box>
                  </>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
        </>
      ) : null}
    </>
  )
}

const blue = {
  200: '#A5D8FF',
  400: '#3399FF',
}

const grey = {
  50: '#F3F6F9',
  100: '#E7EBF0',
  200: '#E0E3E7',
  300: '#CDD2D7',
  400: '#B2BAC2',
  500: '#A0AAB4',
  600: '#6F7E8C',
  700: '#3E5060',
  800: '#2D3843',
  900: '#1A2027',
}

const CustomTablePagination = styled(TablePagination)(
  ({ theme }) => `
  & .${classes.spacer} {
    display: none;
    
  }

  & .${classes.toolbar}  {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    background-color: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};

    @media (min-width: 768px) {
      flex-direction: row;
      align-items: center;
    }
  }

  & .${classes.selectLabel} {
    margin: 0;
    font-size:14px;
  }

  & .${classes.select}{
    padding: 2px;
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
    border-radius: 50px;
    background-color: transparent;
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    font-size:14px;

    &:hover {
      background-color: ${theme.palette.mode === 'dark' ? grey[800] : grey[50]};
      font-size:14px;
    }

    &:focus {
      outline: 1px solid ${theme.palette.mode === 'dark' ? blue[400] : blue[200]};
      font-size:14px;
    }
  }

  & .${classes.displayedRows} {
    margin: 0;
    font-size:14px;

    @media (min-width: 768px) {
      margin-left: auto;
    }
  }

  & .${classes.actions} {
    padding: 2px;
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
    border-radius: 50px;
    text-align: right;
  }

  & .${classes.actions} > button {
    margin: 0 8px;
    border: transparent;
    border-radius: 4px;
    background-color: transparent;
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};

    &:hover {
      background-color: ${theme.palette.mode === 'dark' ? grey[800] : grey[50]};
    }

    &:focus {
      outline: 1px solid ${theme.palette.mode === 'dark' ? blue[400] : blue[200]};
    }

    &:disabled {
      opacity: 0.3;
    }
  }
  `,
)

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}))

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, .05)' : 'rgba(0, 0, 0, .03)',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}))

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}))

export default Reglement
